<template>
    <div class="my-4 ma-md-5 mx-lg-10 mx-xl-10 maxw-1750">
      <v-row no-gutters v-bind:class="['mx-2 align-center', {
        'flex-column justify-center': !$vuetify.breakpoint.mdAndUp
      }]">
        <v-avatar class="gradient-button" size="56" dark>
          <span class="white--text headline text-h6">
            {{ initName }}
          </span>
        </v-avatar>
        <span class="text-h6 ml-4">{{ user.fullName }} </span>
      </v-row>

      <div class="mt-2">
        <v-system-bar color="primary" dark class="bar-intro"> </v-system-bar>
        <v-row id="rowPhoneFields" justify="center" class="pa-md-0 pa-2 ma-md-0 ma-2 mt-md-1">
          <FormUserPerfil
            :id="'formData-phoneFields'"
            ref="expandibleFormData"
            class="pa-4 pa-md-0 formData-userperfil"
            :data="expandableSections"
            :lock="loading"
            :submitVisible="false"
            :profileViewForm="true"
            >
          </FormUserPerfil>
        </v-row>
      </div>
      <v-card-actions
        class="justify-end col-12 px-2 mt-4 mt-md-0"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        <v-btn color="primary"
          @click="submit"
        >
          {{ $t("views.profileEdit.update") }}
        </v-btn>
      </v-card-actions>
      <v-btn
        v-else
        elevation="24"
        @click.stop="submit"
        color="primary"
        fab
        fixed
        isElevated
        right
        bottom
        transition="slide-y-reverse-transition"
        v-bind:style="{ bottom: '70px' }"
      >
        <v-icon>mdi-content-save-outline</v-icon>
      </v-btn>

      <!-- Modal SMS -->
      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            activator="parent"
            width="auto"
            persistent
          >
            <v-card width="auto">
              <v-btn
                icon
                @click="cancel"
                :style="{
                  position: 'absolute',
                  top: '8px',
                  right: 0,
                }"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-card-title class="wordBreak">
                {{ $t("views.profileEdit.popup.title") }}</v-card-title>
              <v-card-text v-bind:style="{ position: 'relative' }">
                {{ $t("views.profileEdit.popup.text") }}
                <br />
                <v-text-field label="Código SMS" ref="codeField" v-model="codeModal"></v-text-field>
                <span
                  class="resend_text"
                  v-if="!errorCode">
                  <a
                    href="#" @click="resend">{{ $t("views.profileEdit.popup.resend") }}</a>
                </span>
                <span
                  class="error_text"
                  v-if="errorCode">
                  {{errorCode === 'incorrectCode'?
                  $t("views.profileEdit.sms.errorCode"):$t("views.profileEdit.sms.errorMax")}}
                </span>
              </v-card-text>
              <v-card-actions>
                <v-row justify="center" dense>
                  <v-btn color="primary" class="btn__pass"
                  @click="isErrorWhatsApp?changeWhatsappPhone():saveDataForm()">
                    {{ $t("views.profileEdit.popup.send") }}
                  </v-btn>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </div>
  </template>

<script>
import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import { NAMED_ROLES } from '@/store/modules/session';
import { FormUserPerfil } from '@/components';

const getClient = (client) => Vue.api.getClient(client);

export default {
  name: 'ProfileView',
  components: {
    FormUserPerfil,
  },
  data() {
    return {
      sessions: [],
      altirisLocation: null,
      loading: false,
      registerSession: [],
      loadingSession: true,
      altirisLocationCoincidence: true,
      altirisMessage: '',
      dialog: false,
      codeField: null,
      codeRandom: null,
      codeModal: null,
      errorCode: null,
      idUserOld: '',
      idUserNew: '',
      countSendSms: 0,
      userbackup: null,
      isErrorWhatsApp: null,
    };
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
      retriesSMS: 'session/retriesSMS',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
    formSections() {
      const sectionsProperties = this.$getConst('profileForm.form');
      return {
        defaultFields: {
          properties: sectionsProperties.defaultFields,
        },
        dirayaFields: {
          name: 'Módulos DIRAYA asignados',
          icon: 'icon-ayudadigital-diraya',
          properties: [],
          id: 'dirayaFields',
          show: true,
          isForm: false,
        },
        phoneFields: {
          name: 'Datos de contacto',
          icon: 'icon-ayudadigital-perfilusuario',
          properties: sectionsProperties.phoneFields,
          id: 'phoneFields',
          show: true,
          isForm: true,
        },
      };
    },
    expandableSections() {
      const sections = this.formSections;
      const menu = ['defaultFields', 'dirayaFields', 'phoneFields'];

      const menuPerfil = menu
        .map((sectionKey) => sections[sectionKey]);
      return { data: menuPerfil };
    },
    initName() {
      return this.user.fullName.split(' ')
        .map((name) => name.charAt(0))
        .join('')
        .substr(0, 2)
        .toUpperCase();
    },
    openPanel() {
      return this.$vuetify.breakpoint.mdAndUp ? [0, 1, 2, 3] : 0;
    },
  },
  methods: {
    fromCallToMe() {
      if (localStorage.getItem('from') === '/calltome') {
        setTimeout(() => {
          console.log('fromCallToMe', document.body.scrollHeight);
          window.scrollTo(0, document.body.scrollHeight);
        }, 1000);
      }
    },
    async submit() {
      const userData = this.$store.getters['session/user'];
      const invalid = [this.$refs.expandibleFormData]
        .some((form) => {
          if (form instanceof Array) {
            // ref is multiple
            return form.some((subform) => !subform.validate());
          }
          // ref is simple
          return !form.validate();
        });

      if (invalid) {
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.profileEdit.form.messages.invalid'),
          icon: 'mdi-times',
          type: 'error',
          timeout: this.$getConst('notifications.timeout'),
        });
        return;
      }

      try {
        const formData = this.$refs.expandibleFormData;
        const formPerfilData = formData.getFormDataWithDeleted();

        const {
          emailAddress: emailForm,
          mobilePhone: contactPhone,
          phoneNumber: anotherPhone,
        } = formPerfilData;

        if (!contactPhone && !anotherPhone) {
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.profileEdit.form.messages.invalidPhone'),
            icon: 'mdi-times',
            type: 'error',
            dismissible: true,
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
          return;
        }

        const { companyIsSAS, emailAddress } = userData;
        const emailPattern = this.$getConst('company.emailPattern');
        if (
          companyIsSAS
          && !emailAddress
          && (emailForm && !emailForm.endsWith(emailPattern))
        ) {
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.profileEdit.form.messages.invalid'),
            icon: 'mdi-times',
            type: 'error',
            timeout: this.$getConst('notifications.timeout'),
          });
          return;
        }

        try {
          formPerfilData.isWhatsappAllowed = formData.$refs['field-isWhatsappAllowed'][0].$children[0].value
            ? '201'
            : '200';
        } catch (error) {
          console.log(error);
        }

        if (
          formPerfilData.mobilePhone !== '' && formPerfilData.mobilePhone !== this.userbackup.mobilePhone
        ) {
          this.showVerificationWindow();
        } else {
          this.saveDataForm();
        }
      } catch (ex) {
        const errEX = ex;
        // const { message } = errEX;
        let errorCgesCode = '';
        if (errEX && errEX.data && errEX.data.errorCgesCode) {
          errorCgesCode = errEX.data.errorCgesCode;
        }
        console.log(errorCgesCode);
      }
    },
    async cancel() {
      const formData = this.$refs.expandibleFormData;
      const form = this.$refs.expandibleFormData.expressionInterpreter.fieldsContext.mobilePhone;
      form.value = this.userbackup.mobilePhone;
      setTimeout(() => {
        formData.$refs['field-mobilePhone'][0].$children[0].$children[0].value = this.userbackup.mobilePhone;
      }, 1000);
      this.dialog = false;
      this.codeModal = null;
      this.codeRandom = null;
    },
    async resend() {
      if (this.retriesSMS < 3) {
        this.$store.dispatch('session/updateRetriesSMS');
        // GENERAR CODIGO
        this.generarCodigo();
        // ENVIO DE SMS
        const formData = this.$refs.expandibleFormData;
        const formPerfilData = formData.getFormDataWithDeleted();

        await this.smsClient.sendSMS(
          this.codeRandom,
          formPerfilData.mobilePhone,
        );
      } else {
        this.errorCode = 'maxRetries';
      }
    },
    async saveDataForm() {
      const notificationMessageId = await this.$store.dispatch(
        'messages/createNotificationMessage',
        {
          title: this.$t('views.profileEdit.form.messages.creating'),
          icon: 'progress-circular',
        },
      );
      let codeVerified = false;
      if (this.codeModal === this.codeRandom) {
        if (this.dialog === true) {
          this.dialog = false;
          this.codeModal = null;
          this.codeRandom = null;
          codeVerified = true;
        }
        try {
          const formData = this.$refs.expandibleFormData;
          const formPerfilData = formData.getFormDataWithDeleted();

          try {
            formPerfilData.isWhatsappAllowed = formData.$refs['field-isWhatsappAllowed'][0].$children[0].value
              ? '201'
              : '200';
          } catch (error) {
            console.log(error);
          }
          const response = await getClient('user').update(formPerfilData);
          if (response && response.total && response.total > 0) {
            const updatedData = response.unique();
            await this.$store.dispatch('session/update', updatedData);
            this.$store.dispatch('session/refreshUserLocationData');
            this.$store.dispatch('messages/updateMessage', {
              id: notificationMessageId,
              title: this.$t('views.profileEdit.form.messages.created'),
              icon: 'mdi-check',
              type: 'success',
              timeout: this.$getConst('notifications.timeout'),
            });
            this.userbackup = updatedData;
          }
        } catch (ex) {
          const errEX = ex;
          const { message } = errEX;
          let errorCgesCode = '';
          if (errEX && errEX.data && errEX.data.errorCgesCode) {
            errorCgesCode = errEX.data.errorCgesCode;
          }
          const errorwWhatsapp = this.$getConst('profileForm.errorWhatsapp');

          // ERROR WHATSAPP
          if (message.includes(errorwWhatsapp)) {
            this.isErrorWhatsApp = true;
            try {
              this.$store.dispatch('messages/removeNotificationMessage', notificationMessageId);
              if (codeVerified) {
                this.changeWhatsappPhone();
              } else {
                this.showVerificationWindow();
              }
            } catch (err) {
              this.$store.dispatch('messages/updateMessage', {
                id: notificationMessageId,
                title: this.$t('views.surveyApp.error'),
                icon: 'mdi-times',
                type: 'error',
                timeout: this.$getConst('notifications.timeout'),
              });
            }
          } else {
            console.log(errorCgesCode);
            this.$store.dispatch('messages/updateMessage', {
              id: notificationMessageId,
              title: this.$t('views.surveyApp.error'),
              icon: 'mdi-times',
              type: 'error',
              timeout: this.$getConst('notifications.timeout'),
            });
          }
        }
      } else {
        this.errorCode = 'incorrectCode';
        this.$store.dispatch('messages/removeNotificationMessage', notificationMessageId);
      }
    },
    async showVerificationWindow() {
      const notificationMessageId = await this.$store.dispatch(
        'messages/createNotificationMessage',
        {
          title: this.$t('views.profileEdit.form.messages.creating'),
          icon: 'progress-circular',
        },
      );
      if (this.retriesSMS < 3) {
        try {
          // GENERAR CODIGO
          this.generarCodigo();
          // ENVIO DE SMS
          const formData = this.$refs.expandibleFormData;
          const formPerfilData = formData.getFormDataWithDeleted();

          const responseSMS = await this.smsClient.sendSMS(
            this.codeRandom,
            formPerfilData.mobilePhone,
          );
          if (responseSMS === 'OK') {
            this.dialog = true;
            this.$store.dispatch('messages/removeNotificationMessage', notificationMessageId);
          } else {
            this.$store.dispatch('messages/updateMessage', {
              id: notificationMessageId,
              title: this.$t('views.surveyApp.error'),
              icon: 'mdi-times',
              type: 'error',
              timeout: this.$getConst('notifications.timeout'),
            });
          }
        } catch (error) {
          const errEX = error;
          let errorCgesCode = '';
          if (errEX && errEX.data && errEX.data.errorCgesCode) {
            errorCgesCode = errEX.data.errorCgesCode;
          }
          console.log(errorCgesCode);
        }
      } else {
        const formData = this.$refs.expandibleFormData;
        const form = this.$refs.expandibleFormData.expressionInterpreter.fieldsContext.mobilePhone;
        form.value = this.userbackup.mobilePhone;
        setTimeout(() => {
          formData.$refs['field-mobilePhone'][0].$children[0].$children[0].value = this.userbackup.mobilePhone;
        }, 1000);

        this.$store.dispatch('messages/updateMessage', {
          id: notificationMessageId,
          title: this.$t('views.profileEdit.sms.errorPriTelephone'),
          icon: 'mdi-times',
          type: 'error',
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    async changeWhatsappPhone() {
      if (this.codeModal === this.codeRandom) {
        if (this.dialog === true) {
          this.dialog = false;
          this.codeModal = null;
          this.codeRandom = null;
        }
        const notificationMessageId = await this.$store.dispatch(
          'messages/createNotificationMessage',
          {
            title: this.$t('views.profileEdit.form.messages.creating'),
            icon: 'progress-circular',
          },
        );
        try {
          // GUARDAR FORMULARIO SIN WHATSAPP
          const formData = this.$refs.expandibleFormData;
          const newFormPerfilData = formData.getFormDataWithDeleted();
          newFormPerfilData.isWhatsappAllowed = '200';
          const responseUpdate = await getClient('user').update(newFormPerfilData);
          const updatedDataUser = responseUpdate.unique();
          this.userbackup = updatedDataUser;
          await this.$store.dispatch('session/update', updatedDataUser);
          this.$store.dispatch('session/refreshUserLocationData');
          // OBTENER DATOS DEL USUARIO CON EL MISMO NUMERO DE TELEFONO
          const {
            id,
            userid,
            dni,
            mobilePhone,
          } = this.$store.getters['session/user'];
          const response = await this.userClient.getuserFromPhoneSMS({
            apiCges: {
              delegado: userid,
              uuidSuscriptor: id,
              endpoint: 'user/phone',
            },
            phone: mobilePhone,
            dni,
          });
          const { collection_nr: collectionNr } = response;

          if (collectionNr && collectionNr.nr && collectionNr.nr.length > 0) {
            const userID = collectionNr?.nr[0]['@id'];
            // MODIFICAR CHECK WHATSAPP AL OTRO USUARIO
            const formUserOldWhatsapp = { isWhatsappAllowed: '200' };
            await getClient('user').update(formUserOldWhatsapp, userID);
            // MODIFICAR CHECK WHATSAPP AL NUEVO USUARIO
            const formUserNewWhatsapp = { isWhatsappAllowed: '201' };
            const responseNewUser = await getClient('user').update(formUserNewWhatsapp);
            const updatedData = responseNewUser.unique();
            this.userbackup = updatedData;
            await this.$store.dispatch('session/update', updatedData);
            this.$store.dispatch('session/refreshUserLocationData');
            this.$store.dispatch('messages/updateMessage', {
              id: notificationMessageId,
              title: this.$t('views.profileEdit.sms.ok'),
              icon: 'mdi-check',
              type: 'success',
              timeout: this.$getConst('notifications.timeout'),
            });
          } else {
            this.$store.dispatch('messages/updateMessage', {
              id: notificationMessageId,
              title: this.$t('views.surveyApp.error'),
              icon: 'mdi-times',
              type: 'error',
              timeout: this.$getConst('notifications.timeout'),
            });
          }
        } catch (error) {
          this.$store.dispatch('messages/updateMessage', {
            id: notificationMessageId,
            title: this.$t('views.surveyApp.error'),
            icon: 'mdi-times',
            type: 'error',
            timeout: this.$getConst('notifications.timeout'),
          });
          console.log(error);
        }
      }
    },
    calculateSymbol(soporte) {
      const symbol = soporte ? soporte.split(' ')[0].toLowerCase() : 'unknow';
      if (!this.$te(`views.profileEdit.session.symbol.${symbol}`)) {
        return this.$t('views.profileEdit.session.symbol.unknow');
      }
      return this.$t(`views.profileEdit.session.symbol.${symbol}`);
    },
    async altirisSeach() {
      const client = this.$api.getClient('search');
      let list = [];
      try {
        const user = this.$store.getters['session/user'];
        const response = await client.search({
          target: 'namedquery',
          entity: 'altirisRecent',
          filters: JSON.stringify({
            user: user.userid,
            time: 2 * 24 * 60 * 60,
          }),
          apicges: {
            delegado: user.id,
            endpoint: 'altiris/recursos/infraestructura',
          },
        });

        list = response.list;
      } catch (ex) {
        console.error('error retrieving altiris items', ex);
      }
      return list;
    },
    async getAltirisLocation(resource) {
      if (resource === undefined) {
        return undefined;
      }
      const client = this.$api.getClient('search');
      let res;
      try {
        const response = await client.search({
          target: 'backend',
          entity: 'loc',
          fields: 'location_uuid,location_name',
          filters: JSON.stringify({
            ZCODIGO_CENTRO: resource.ubicacionCodigoCentro,
          }),
        });
        if (response.list && response.list.length > 0) {
          [res] = response.list;
        }
      } catch (ex) {
        console.error('error retrieving bussiness types', ex);
      }
      return res;
    },
    // updateLocationWithAltiris() {
    //   const formLocation = this.$refs.expandibleFormData.find(
    //     (formulario) => formulario.data.id === 'workplaceFields',
    //   );
    //   if (formLocation === null) {
    //     return;
    //   }
    //   const [locationField] = formLocation.$refs['field-location'];
    //   if (locationField !== undefined) {
    //     const [searchItem] = locationField.$children;
    //     searchItem.makeSearch(this.altirisLocation.id);
    //     this.altirisLocationCoincidence = true;
    //   }
    //   // eslint-disable-next-line dot-notation
    //   const [relLocationEdificios] = formLocation.$refs['field-zrel_location_edificios'];
    //   if (relLocationEdificios !== undefined) {
    //     relLocationEdificios.fieldValue.item = null;
    //     relLocationEdificios.fieldValue.value = '';
    //   }
    //   const [relLocationPlantas] = formLocation.$refs['field-zrel_location_plantas'];
    //   if (relLocationPlantas !== undefined) {
    //     relLocationPlantas.fieldValue.item = null;
    //     relLocationPlantas.fieldValue.value = '';
    //   }
    //   const [salaField] = formLocation.$refs['field-roomLocation'];
    //   if (salaField !== undefined) {
    //     salaField.fieldValue.value = '';
    //     const [textField] = salaField.$children;
    //     textField.visibleValue = '';
    //   }
    // },
    generarCodigo() {
      const codigo = Math.floor(100000 + Math.random() * 900000);
      this.codeRandom = codigo.toString();
      this.temporizador = setTimeout(() => {
        this.codeRandom = null;
      }, 3600000);
    },
    selectElement() {
      const inputElement = document.querySelector('[role="switch"][type="checkbox"]');

      if (inputElement && inputElement.getAttribute('aria-checked') === 'true' && inputElement.getAttribute('aria-disabled') === 'false') {
        inputElement.click();
      }
    },
    selectSwitch() {
      const labelText = 'Móvil de contacto'; // El texto a buscar en las etiquetas de tipo 'label'
      const labels = document.getElementsByTagName('label');

      for (let i = 0; i < labels.length; i += 1) {
        const label = labels[i];
        if (label.textContent.includes(labelText)) {
          const inputId = label.getAttribute('for');
          const input = document.getElementById(inputId);
          if (input && input.value === '') {
            const inputElement = document.querySelector('[role="switch"][type="checkbox"]');

            if (inputElement && inputElement.getAttribute('aria-checked') === 'false' && inputElement.getAttribute('aria-disabled') === 'false') {
              inputElement.click();
            }
          }
        }
      }
    },
  },
  async created() {
    this.$root.$on('deleteTextFormPerfil', () => {
      this.selectElement();
    });
    this.$root.$on('deletePhoneContact', () => {
      this.selectElement();
    });
    this.$root.$on('changeSwitch', () => {
      this.selectSwitch();
    });
    this.userClient = this.$api.getClient('user');

    this.smsClient = this.$api.getClient('sms');
    this.NAMED_ROLES = NAMED_ROLES;
    const resource = await this.altirisSeach();
    if (resource === undefined || resource.length === 0) {
      return;
    }
    this.altirisLocation = await this.getAltirisLocation(resource[0]);
    if (this.altirisLocation === undefined) {
      return;
    }
    const user = this.$store.getters['session/user'];
    this.altirisLocationCoincidence = user.location.id === this.altirisLocation.id;
    this.altirisMessage = this.$t('views.profileEdit.altirisMessage', [this.altirisLocation.name]);
    this.$forceUpdate();
  },
  async mounted() {
    const user = this.$store.getters['session/user'];
    this.userbackup = { ...user };
    this.fromCallToMe();
  },
};
</script>
  <style lang="scss" scoped>
  $header-padding: 10 0;
  .bar-intro {
    height: 3px !important;
  };
  .color-border {
    border: 1px solid !important;
    border-color: #002060 !important;
  }
  .v-expansion-panel-header {
    padding: $header-padding;
  }
  .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: initial;
  }
  .contenData-whatsappFields {
    margin-top: -1.5rem;
  }
  .formData-userperfil {
    padding-right: 9px !important;
    padding-left: 9px !important;
  }
  .v-expansion-panel::before{
    box-shadow: none !important;
  }
  </style>

  <style lang="scss">
  .v-dialog > .v-card > .v-card__text {
    padding: 0 24px 0px !important;
  }

  .timeLeft {
    color: #B64351 !important;
  }

  .error_text {
    color: #b00020;
    font-size: 14px;
    font-weight: 400;
    bottom: 0;
  }
  .resend_text {
    font-size: 14px;
    font-weight: 400;
    bottom: 0;
  }
  .v-input--selection-controls {
    margin-left: 0px !important;
  }

  .v-treeview.theme--light {
    margin: 0px 0.5rem;
  }

  .wrapper__diraya   {
    padding: 0px;
  }

  .v-treeview-node {
    padding-bottom: 0;
  }
  .v-treeview-node__label {
    white-space: initial !important;
  }

  .btn__pass {
    margin-top: 5px;
  }
  .wordBreak {
    word-break: break-word;
  }
  </style>
